import type { ComponentProps } from 'react'
import { LoadingIcon } from './icons/LoadingIcon'

type Props = ComponentProps<typeof LoadingIcon>

export function Spinner(props: Props) {
  return (
    <div className="animate-spin">
      <LoadingIcon {...props} />
    </div>
  )
}
